/* Frequently bought together — behaviour for the native block (snippets/llm-fbt.liquid).
   Replaces the Code Black Belt widget's client-side work. Everything it needs is already in the DOM
   (rendered server-side from custom.fbt_products), so this makes no network call until the customer
   actually adds to cart. */
(function () {
  var root = document.querySelector('[data-llm-fbt]');
  if (!root) return;

  var sheet  = root.querySelector('[data-llm-fbt-sheet]');
  var scrim  = root.querySelector('[data-llm-fbt-scrim]');
  var addBtn = root.querySelector('[data-llm-fbt-add]');
  var hint   = root.querySelector('[data-llm-fbt-hint]');
  var rows   = Array.prototype.slice.call(root.querySelectorAll('[data-llm-fbt-row]'));

  /* Money formatting. Shopify's money filter already rendered a formatted value server-side, but the
     total changes as the customer picks variants, so it has to be built here too. Reading the
     store's own format string rather than hardcoding "$" keeps it correct if currency ever changes. */
  /* Must match PERCENTAGE in extensions/fbt-bundle-discount/src/run.ts. If the Shopify Function's
     rate ever changes, this display becomes a lie until it is changed here too — there is no way to
     read the function's value from the storefront. */
  var PERCENT_OFF = 0.05;

  var FORMAT = (window.Shopify && window.Shopify.money_format) || '${{amount}}';
  function money(cents) {
    var v = (cents / 100).toFixed(2);
    var parts = v.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var amount = parts.join('.');
    return FORMAT.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  }

  /* Same amount, with the cents raised to match every other price on the page (owner 2026-09-04).
     llm-money.js does the identical cents->format->superscript pass, so this block does not get its
     own second opinion on how money looks. Callers use innerHTML; if llm-money.js is missing they
     fall back to the flat string rather than printing tags as text. */
  function moneyHtml(cents) {
    return window.llmMoney ? window.llmMoney.fromCents(cents) : money(cents);
  }
  function setMoney(el, cents, suffix) {
    if (window.llmMoney) el.innerHTML = moneyHtml(cents) + (suffix || '');
    else el.textContent = money(cents) + (suffix || '');
  }

  function rowState(row) {
    var check = row.querySelector('[data-llm-fbt-check]');
    var field = row.querySelector('[data-llm-fbt-variant]');
    return {
      checked: !!(check && check.checked),
      variantId: field ? field.value : '',
      cents: field ? parseInt(field.getAttribute('data-cents') || '0', 10) : 0,
    };
  }

  /* Samples and trial packs are never CHOSEN FOR the customer (owner 2026-09-05). They are the
     cheapest variant of almost every product, so "pick the cheapest" landed on them, and they are
     usually first in variant order, so "first match at this size" did too — a $64.99 bundle would
     quietly include a $2.99 one-count sample. The customer can still pick one deliberately in the
     popup; this only governs what the block selects on its own.

     Whole-title match, no positional logic: mined from the live catalogue with
     zz_sample_trial_scan.mjs — 12,808 variants, 205 matches, 9 distinct segments, all genuine sample
     units and ZERO false positives (nothing uses "sample" as a product form, e.g. a specimen cup).
     The word is usually the pack segment ("Trial Pack of 4", "Sample (1 count)") but leads in 5
     cases ("Sample | MD (1 count)"), so testing the whole string is both simpler and correct. */
  function isSampleOrTrial(v) {
    return !!v && /\b(sample|trial)\b/i.test(String(v.f || v.t || ''));
  }

  /* Out-of-stock variants are LISTED but never selectable (owner 2026-09-05). The snippet now emits
     every variant with `a`, so a customer whose size is sold out sees it struck through instead of
     finding a silent hole in the list.

     ⚠️ This deliberately DIVERGES from the page's own popup, where sold-out options stay clickable so
     the Klaviyo "Notify me when available" trigger can attach to them (see llm-option-popup.css).
     There is no back-in-stock flow inside a bundle, so a click there would only produce an add-to-cart
     that fails. Defaults to available when `a` is absent, so an older cached snippet payload cannot
     blank out every option. */
  function isBuyable(v) {
    return !!v && v.a !== 0;
  }

  // Variant list for a row, parsed once from the JSON the snippet emitted.
  function variantsOf(row) {
    if (row._llmVariants) return row._llmVariants;
    var tag = row.querySelector('[data-llm-fbt-variants]');
    try { row._llmVariants = tag ? JSON.parse(tag.textContent) : []; }
    catch (e) { row._llmVariants = []; }
    return row._llmVariants;
  }

  // Write a choice back into the row: hidden field, trigger label, price.
  function selectVariant(row, v, byUser) {
    var field = row.querySelector('[data-llm-fbt-variant]');
    var label = row.querySelector('[data-llm-fbt-trigger-label]');
    var priceEl = row.querySelector('[data-llm-fbt-price]');
    if (!field) return;
    field.value = v ? String(v.i) : '';
    field.setAttribute('data-cents', v ? String(v.p) : '0');
    if (label) label.textContent = v ? v.t : 'Choose an option…';
    // Only the amount is stored here; refresh() paints it, because whether the 5% applies depends
    // on the OTHER rows' checkboxes and can change without this row being touched.
    if (priceEl) priceEl.setAttribute('data-cents', v ? String(v.p) : '0');
    if (byUser) row.dataset.userSet = '1';
    // A deliberate change to THIS ITEM's row has to move the page's own picker too, or the PDP shows
    // two different prices for one product and "Add all" adds a variant the buy box never displayed.
    if (byUser && v && row.hasAttribute('data-llm-fbt-anchor')) pushToPicker(v);
    refresh();
  }

  /* The option popup. Built with llm-option-popup.js's OWN class names so it inherits
     llm-option-popup.css and looks identical to the product page and Quick Buy — but standalone,
     because that script drives the page's product form and must not be pointed at a partner. */
  var openPopup = null;
  function closePopup() {
    if (!openPopup) return;
    openPopup.overlay.remove();
    openPopup.trigger.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('llm-fbt-locked');
    openPopup = null;
  }
  /* The split rows inside the popup. A click on an in-stock combination selects it for the bundle
     straight away, as on the product page; a sold-out one is shown but never enters the bundle (see
     isBuyable). Until the shopper clicks, the rows only PREVIEW a starting point — the row stays
     unset, keeping the never-preselect rule. Returns false when the rows cannot be drawn. */
  function drawSplit(row, list, pop, current) {
    var S = window.llmSplit;
    if (!S || list.length < 2) return false;
    var tag = row.querySelector('[data-llm-fbt-variants]');
    var names = null;
    try { names = tag && tag.getAttribute('data-names') ? JSON.parse(tag.getAttribute('data-names')) : null; } catch (e) { names = null; }
    var multi = !!(names && list[0].o);
    if (!multi && !S.wanted(list.map(function (v) { return v.f || v.t; }))) return false;
    var valueMap = {};
    try { var vd = row.querySelector('[data-llm-fbt-value]'); if (vd) valueMap = JSON.parse(vd.textContent); } catch (e) { valueMap = {}; }

    // Rebuilt on every draw: the renderer reorders each row's parts in place.
    function mkRows() {
      return list.map(function (v) {
        return { v: v, vid: String(v.i), oos: !isBuyable(v),
          parts: multi ? v.o.map(function (p) { return String(p).trim(); }) : S.parts(v.f || v.t) };
      });
    }
    // Starting point shown: the row's variant, else this product's size in stock, else anything in stock.
    var want = anchorSize();
    var start = list.filter(function (v) { return String(v.i) === String(current); })[0]
      || list.filter(function (v) { return isBuyable(v) && !isSampleOrTrial(v) && want && sizeToken(v.s) === want; })[0]
      || list.filter(function (v) { return isBuyable(v) && !isSampleOrTrial(v); })[0]
      || list.filter(isBuyable)[0] || list[0];
    var pickId = String(start.i);

    var box = document.createElement('div');
    box.className = 'llm-variant-tiles llm-variant-tiles--split llm-fbt-split';
    var foot = document.createElement('div');
    foot.className = 'llm-fbt-split__foot';
    var price = document.createElement('div');
    price.className = 'llm-fbt-split__price';
    var done = document.createElement('button');
    done.type = 'button';
    done.className = 'btn btn--primary llm-fbt-split__done';
    foot.appendChild(price);
    foot.appendChild(done);
    pop.appendChild(box);
    pop.appendChild(foot);

    function draw() {
      var rows = mkRows();
      var sel = rows.filter(function (r) { return r.vid === pickId; })[0] || rows[0];
      S.render(box, rows, sel, function (r) {
        pickId = r.vid;
        if (!r.oos) selectVariant(row, r.v, true);
        draw();
      }, multi ? names : null, valueMap);
      var v = sel.v, info = valueMap[sel.vid];
      var per = info && info.per && info.count > 1 ? info.per + '/ea' : (v.u ? money(v.u) + '/ea' : '');
      price.textContent = '';
      var amt = document.createElement('b'); amt.textContent = money(v.p); price.appendChild(amt);
      if (per) { var u = document.createElement('span'); u.className = 'llm-fbt-split__unit'; u.textContent = per; price.appendChild(u); }
      if (sel.oos) { var o = document.createElement('span'); o.className = 'llm-fbt-split__oos'; o.textContent = 'Out of stock'; price.appendChild(o); }
      var chosen = (row.querySelector('[data-llm-fbt-variant]') || {}).value === sel.vid;
      done.disabled = sel.oos;
      done.textContent = sel.oos ? 'Choose an in-stock option' : 'Done';
      /* "Done" with an un-clicked starting point still has to choose it — closing without a choice
         would leave the row unset after the shopper saw it looking selected. */
      done.onclick = function () { if (!sel.oos && !chosen) selectVariant(row, v, true); closePopup(); };
    }
    draw();
    return true;
  }

  function showPopup(row, trigger) {
    closePopup();
    var list = variantsOf(row);
    if (!list.length) return;
    var titleEl = row.querySelector('.llm-fbt__title');
    var name = titleEl ? titleEl.textContent.replace(/^\s*This item:\s*/, '').trim() : 'Choose an option';

    var overlay = document.createElement('div');
    /* Second class raises the stacking order. llm-option-popup.css puts the overlay at z-index 1010,
       which is fine on the product page but sits BEHIND this block's own mobile sheet (9999) — the
       popup opened and was covered by the panel that launched it. */
    overlay.className = 'llm-option-popup-overlay llm-fbt-optionpopup';
    var pop = document.createElement('div');
    pop.className = 'llm-option-popup';
    pop.setAttribute('role', 'dialog');
    pop.setAttribute('aria-modal', 'true');

    var header = document.createElement('div');
    header.className = 'llm-option-popup__header';
    var heading = document.createElement('p');
    heading.className = 'llm-option-popup__heading';
    heading.textContent = name;
    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'llm-option-popup__close';
    close.setAttribute('aria-label', 'Close');
    close.innerHTML = '<svg viewBox="0 0 16 16" fill="none" aria-hidden="true"><path d="M3 3l10 10M13 3L3 13" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>';
    header.appendChild(heading);
    header.appendChild(close);
    pop.appendChild(header);

    /* TILE GRID, matching the site's own popup exactly — same classes, same inner structure, so it
       inherits llm-option-popup.css and is indistinguishable from the product page picker. Read off
       the live popup rather than guessed: .llm-option-popup__tile-grid > .llm-variant-tile with
       __name (one __name-line per title segment), __price, __unit, __sku. An earlier version used a
       row list with SKUs, which was a different component and looked nothing like the rest of the
       site — the owner asked for the same picker, only reached from a plain dropdown. */
    var current = (row.querySelector('[data-llm-fbt-variant]') || {}).value;

    /* BUTTON ROWS (owner 2026-10-27: "can you have the variant picker look the same for this modal?").
       The Size / Color / Package rows of the product page, drawn by the SAME function
       (window.llmSplit from llm-option-popup.js) — not a copy. Falls back to the tile grid below
       when that script is absent or the values do not split evenly, exactly as the product page does. */
    if (drawSplit(row, list, pop, current)) {
      close.addEventListener('click', closePopup);
      overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
      overlay.appendChild(pop);
      document.body.appendChild(overlay);
      overlay.classList.add('is-open');
      document.body.classList.add('llm-fbt-locked');
      trigger.setAttribute('aria-expanded', 'true');
      openPopup = { overlay: overlay, trigger: trigger };
      return;
    }
    var grid = document.createElement('div');
    grid.className = 'llm-option-popup__tile-grid';

    list.forEach(function (v) {
      var tile = document.createElement('button');
      tile.type = 'button';
      tile.className = 'llm-variant-tile';
      if (String(v.i) === String(current)) tile.classList.add('is-selected');

      var nm = document.createElement('span');
      nm.className = 'llm-variant-tile__name';
      // The site splits the option title across lines, one per " | " segment.
      String(v.f || v.t).split('|').forEach(function (seg) {
        var line = document.createElement('span');
        line.className = 'llm-variant-tile__name-line';
        line.textContent = seg.trim();
        nm.appendChild(line);
      });
      tile.appendChild(nm);

      /* Flat cents inside the picker, matching llm-option-popup.js — these are variant cards and a
         unit price, both of which Amazon leaves alone (owner 2026-09-05). The FBT block's own row
         prices and bundle total below DO keep the superscript; they are primary prices. */
      var pr = document.createElement('span');
      pr.className = 'llm-variant-tile__price';
      pr.textContent = money(v.p);
      tile.appendChild(pr);

      if (v.u) {
        var unit = document.createElement('span');
        unit.className = 'llm-variant-tile__unit';
        unit.textContent = money(v.u) + '/ea';
        tile.appendChild(unit);
      }
      if (v.k) {
        var sku = document.createElement('span');
        sku.className = 'llm-variant-tile__sku';
        sku.textContent = v.k;
        tile.appendChild(sku);
      }

      /* Sold out: shown, struck through, and inert. No click listener at all rather than a listener
         that returns early — nothing to mis-fire later. aria-disabled + tabindex -1 keep it out of
         the keyboard path, so it reads as "exists, unavailable" to a screen reader instead of being
         an unlabelled dead control. */
      if (!isBuyable(v)) {
        tile.classList.add('is-unavailable');
        tile.setAttribute('aria-disabled', 'true');
        tile.setAttribute('tabindex', '-1');
        var oos = document.createElement('span');
        oos.className = 'llm-variant-tile__oos';
        oos.textContent = 'Out of stock';
        tile.appendChild(oos);
      } else {
        tile.addEventListener('click', function () { selectVariant(row, v, true); closePopup(); });
      }
      grid.appendChild(tile);
    });
    pop.appendChild(grid);

    close.addEventListener('click', closePopup);
    overlay.addEventListener('click', function (e) { if (e.target === overlay) closePopup(); });
    overlay.appendChild(pop);
    document.body.appendChild(overlay);
    /* llm-option-popup.css hides .llm-option-popup-overlay by default and reveals it with .is-open.
       Inheriting that stylesheet means inheriting the hidden default too — without this the popup
       was built correctly (all 72 rows, right heading) and simply never displayed. */
    overlay.classList.add('is-open');
    document.body.classList.add('llm-fbt-locked');
    trigger.setAttribute('aria-expanded', 'true');
    openPopup = { overlay: overlay, trigger: trigger };
    close.focus();
  }

  /* Does the cart the customer is about to build actually EARN the 5%?
     Mirrors run.ts in the fbt-bundle-discount function exactly: it needs the anchor line present,
     at least one verified partner alongside it, and two lines minimum. Untick the anchor and the
     partners get nothing — so the prices must stop claiming a discount too. Showing 5% off a
     combination that will not receive it is a false price, which is the one thing a price display
     must never do. */
  function bundleQualifies() {
    var anchorTicked = false;
    var partnersTicked = 0;
    rows.forEach(function (row) {
      var s = rowState(row);
      /* TICKED is the test, deliberately NOT "ticked and has a variant chosen".
         On load the partners are ticked but unchosen, so requiring a resolved variant left the
         first row showing its FULL price directly under a badge promising "Save 5% by buying these
         together", and the price only dropped once an unrelated row was configured — which reads
         as a bug (owner 2026-09-05). A ticked row is a row the customer intends to buy, and the
         Add button already refuses to submit until every ticked row has a variant, so by the time
         anything reaches the cart the bundle genuinely qualifies. Untick the anchor, or every
         partner, and this correctly goes false again. */
      if (!s.checked) return;
      if (row.hasAttribute('data-llm-fbt-anchor')) anchorTicked = true;
      else partnersTicked++;
    });
    return anchorTicked && partnersTicked >= 1;
  }

  /* Per-line, not on the total. The function targets each cart LINE with a percentage discount, so
     Shopify rounds per line — summing the rounded lines matches the receipt more closely than
     rounding one grand total, which could differ by a cent on a three-item bundle. */
  function lineDiscounted(cents) {
    return Math.round(cents * (1 - PERCENT_OFF));
  }

  function renderRowPrice(row, cents, discountApplies) {
    var el = row.querySelector('[data-llm-fbt-price]');
    if (!el) return;
    el.textContent = '';
    if (!cents) return;
    if (!discountApplies) { setMoney(el, cents); return; }
    var now = document.createElement('span');
    now.className = 'llm-fbt__price-now';
    setMoney(now, lineDiscounted(cents));
    var was = document.createElement('s');
    was.className = 'llm-fbt__price-was';
    setMoney(was, cents);
    el.appendChild(now);
    el.appendChild(document.createTextNode(' '));
    el.appendChild(was);
  }

  function refresh() {
    var total = 0, chosen = 0, missing = 0;
    var qualifies = bundleQualifies();
    rows.forEach(function (row) {
      var s = rowState(row);
      row.classList.toggle('is-unset', s.checked && !s.variantId);

      /* Painted for every row that HAS a variant, ticked or not — an unticked row still shows its
         price, it just shows the undiscounted one, so ticking it visibly earns the saving. */
      renderRowPrice(row, s.variantId ? s.cents : 0, qualifies && s.checked);

      if (!s.checked) return;
      if (!s.variantId) { missing++; return; }
      chosen++;
      total += s.cents;
    });

    /* Count TICKED rows, not rows that already have a variant. It previously read "Add all 1 to
       cart" on a three-item bundle simply because two sizes were still unchosen — the number is
       about what is included, not what has been configured. */
    var ticked = 0;
    rows.forEach(function (row) { if (rowState(row).checked) ticked++; });
    var countEl = root.querySelector('[data-llm-fbt-count]');
    if (countEl) countEl.textContent = String(ticked);

    /* While anything is still unchosen, show a prompt instead of a number. A partial sum reads as
       the bundle price and undersells it — on first load with two rows unmatched it said "$2.99"
       for a three-item bundle. Only show money once every ticked row has a variant. */
    var totalEl = root.querySelector('[data-llm-fbt-total]');
    var pillTotal = root.querySelector('[data-llm-fbt-pill-total]');

    /* The 5% comes off in the cart, applied by the fbt-bundle-discount Shopify Function. Showing the
       discounted figure with the full price struck through matches what the customer will actually
       be charged. Rounded the same way Shopify does — to the cent, on the bundle total. */
    /* Sum of the per-line discounted amounts, so the total and the rows can never disagree — and
       only when the bundle actually qualifies (see bundleQualifies). Untick the anchor and this
       correctly falls back to the plain total. */
    var discounted = 0;
    if (qualifies) {
      rows.forEach(function (row) {
        var s = rowState(row);
        if (s.checked && s.variantId) discounted += lineDiscounted(s.cents);
      });
    } else {
      discounted = total;
    }
    if (missing > 0) {
      /* ⚠️ "Choose options ABOVE" POINTED THE WRONG WAY ON DESKTOP — owner, 2026-10-10. The foot
         sits to the RIGHT of the product rows at desktop widths and only stacks beneath them on
         mobile, so the single word carrying the instruction was wrong for most visitors.
         It was also redundant: `hint` directly below already reads "Choose an option for each item
         to continue" whenever missing > 0 (see `hint.hidden = missing === 0`), and that sentence is
         direction-neutral, so it is correct in BOTH layouts.
         A price slot should therefore show the ABSENCE of a price, not repeat the instruction.
         ⛔ Not `{{ 0 | money }}` / "$0.00" — that reads as a bundle that costs nothing. */
      if (totalEl) totalEl.textContent = '$—';
      if (pillTotal) pillTotal.textContent = 'Choose options';
    } else {
      if (totalEl) {
        totalEl.textContent = '';
        var now = document.createElement('span');
        now.className = 'llm-fbt__total-now';
        setMoney(now, discounted);
        totalEl.appendChild(now);
        // Struck price only when there is actually a saving — with the anchor unticked the bundle
        // earns nothing, and "$X $X" with one struck reads as a discount that is not happening.
        if (discounted < total) {
          var was = document.createElement('s');
          was.className = 'llm-fbt__total-was';
          setMoney(was, total);
          totalEl.appendChild(document.createTextNode(' '));
          totalEl.appendChild(was);
        }
      }
      if (pillTotal) setMoney(pillTotal, discounted);
    }
    var totalWrap = root.querySelector('.llm-fbt__total');
    if (totalWrap) totalWrap.classList.toggle('is-prompt', missing > 0);

    var ok = chosen >= 2 && missing === 0;
    addBtn.disabled = !ok;
    if (hint) hint.hidden = missing === 0;
  }

  /* ---- size mirroring ------------------------------------------------------------------------
     Follow the size the customer picked on the product itself.

     The app we are replacing does NOT do this: every one of its dropdowns sits at selectedIndex 0,
     so on a page set to XL it still offers MD for the add-ons, and anyone who trusts the defaults
     buys the wrong size. Verified live — PDP on SM, its rows showed SM / MD / MD, all index 0.

     ⚠️ Only ever selects on an EXACT size-token match. Vocabularies differ between products
     ("SM (21\" to 31\")" vs "MD (28\" to 43\")") and pack counts share the same string, so a fuzzy
     "closest size" would produce a confident-looking wrong answer — the precise failure the
     no-default rule exists to prevent. No confident match leaves the row unset and the button
     disabled, which is the safe fallback rather than a guess. */
  var SIZE_ALIASES = {
    XS: 'XS', 'X-SMALL': 'XS', 'EXTRA SMALL': 'XS',
    S: 'SM', SM: 'SM', SMALL: 'SM',
    M: 'MD', MD: 'MD', MEDIUM: 'MD', MED: 'MD',
    L: 'LG', LG: 'LG', LARGE: 'LG',
    XL: 'XL', 'X-LARGE': 'XL', 'XLARGE': 'XL',
    XXL: '2XL', '2XL': '2XL', XXXL: '3XL', '3XL': '3XL', '4XL': '4XL', '5XL': '5XL',
  };
  /* Find the size in a variant title.
     ⚠️ Scans EVERY pipe-separated segment, not just the first. This catalogue crams several
     attributes into one option value — NorthShore MEGAMAX reads "White | XS (18" to 30") | Trial
     Pack of 4" — so reading only the head returned "WHITE" and mirroring silently did nothing on
     every product whose option leads with a colour. */
  function sizeToken(title) {
    if (!title) return null;
    var segments = String(title).split('|');
    for (var i = 0; i < segments.length; i++) {
      var head = segments[i].split('(')[0].trim().toUpperCase().replace(/[.,]/g, '');
      if (!head) continue;
      if (SIZE_ALIASES[head]) return SIZE_ALIASES[head];
      var first = head.split(/[\s/]+/)[0];
      if (SIZE_ALIASES[first]) return SIZE_ALIASES[first];
    }
    return null;
  }

  function currentPdpSize() {
    // The theme renders the selected option's label here; it is the one place the full option
    // string is available without re-deriving it from the variant id.
    var el = document.querySelector('.llm-option-trigger-label__value');
    return el ? sizeToken(el.textContent) : null;
  }

  /* The size to mirror, taken from the ANCHOR ROW's own variant rather than the page label.
     .llm-option-trigger-label__value is maintained by llm-option-popup.js and only updates when the
     customer uses THAT popup — it does not follow a variant changed any other way. Measured
     2026-09-05: picker and URL on "MD | Pack of 10" while the label still read "SM | Trial Pack of
     4", so both partners stayed on SM despite each having an MD variant. The anchor row is set by
     syncAnchor from the variant id and is correct in every path, including a change made inside this
     block. Falls back to the label only when the anchor cannot be resolved (e.g. out-of-stock
     variant absent from the emitted list). */
  function anchorSize() {
    var row = root.querySelector('[data-llm-fbt-anchor]');
    var field = row && row.querySelector('[data-llm-fbt-variant]');
    if (field && field.value) {
      var list = variantsOf(row);
      for (var i = 0; i < list.length; i++) {
        if (String(list[i].i) === String(field.value)) return sizeToken(list[i].s);
      }
    }
    return currentPdpSize();
  }

  function mirrorSizes() {
    var want = anchorSize();
    if (!want) return;                       // product has no recognisable size — leave rows alone
    rows.forEach(function (row) {
      /* NEVER the anchor. Its variant is not a guess to be mirrored — syncAnchor already set it from
         the page's own picker, by id. Mirroring would re-pick by SIZE and land on the first variant
         of that size, i.e. the smallest pack: selecting "SM | Case of 40" on the product made this
         row silently revert to "SM | Trial Pack of 4" ~1s later, so "Add all 3" added a pack the buy
         box never displayed. Measured 2026-09-05: syncAnchor set it correctly at +19ms, mirrorSizes
         overwrote it at +945ms. userSet does not protect it — syncAnchor passes byUser=false. */
      if (row.hasAttribute('data-llm-fbt-anchor')) return;
      if (row.dataset.userSet === '1') return;   // never overwrite a deliberate choice
      if (!row.querySelector('[data-llm-fbt-trigger]')) return;   // single-variant row, nothing to pick
      var list = variantsOf(row);
      for (var i = 0; i < list.length; i++) {
        // `s` is the raw size segment written server-side; the visible label has the colour stripped
        // and the marketing note removed, so it is not a reliable thing to parse — this is.
        // Samples/trials are skipped: they sort first, so this loop used to hand the bundle a
        // one-count sample whenever one existed at the wanted size.
        if (isSampleOrTrial(list[i]) || !isBuyable(list[i])) continue;
        if (sizeToken(list[i].s) === want) { selectVariant(row, list[i], false); return; }
      }
      selectVariant(row, null, false);         // no match at this size — unset, not a guess
    });
  }

  rows.forEach(function (row) {
    // Only the checkbox fires change now — the variant control is a button + popup.
    row.addEventListener('change', refresh);
    var trig = row.querySelector('[data-llm-fbt-trigger]');
    if (trig) trig.addEventListener('click', function () { showPopup(row, trig); });
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && openPopup) closePopup();
  });

  /* Re-mirror whenever the shopper changes size on the product itself.

     ⚠️ Deferred, not immediate. `on:variant:change` fires BEFORE the theme rewrites
     .llm-option-trigger-label__value, so reading it synchronously gets the previous size and mirrors
     to the wrong one. Verified: dispatching the event by hand once the label had settled mirrored
     all three rows correctly, while the real event during a tile click did nothing. */
  document.addEventListener('on:variant:change', function () {
    setTimeout(mirrorSizes, 120);
  });

  /* On first load the label is built by llm-option-popup.js, which may not have run yet — the first
     mirror attempt found no size and bailed, leaving every row unset. Poll briefly for it instead of
     assuming a fixed order between two independent deferred scripts. */
  function mirrorWhenReady(triesLeft) {
    if (currentPdpSize()) { mirrorSizes(); return; }
    if (triesLeft <= 0) return;               // no size on this product — leave rows unset
    setTimeout(function () { mirrorWhenReady(triesLeft - 1); }, 150);
  }

  /* ---- funnel logging ----------------------------------------------------------------------- */
  /* WHY: this block fired NO analytics of any kind. The only trace FBT left was the 5% automatic
     discount landing on an order — which counts buyers and is blind to everyone who saw the bundle
     and walked past it. The owner asked "can you tell by the discount given?" (2026-09-20): you can
     tell REVENUE that way, but not USAGE, and those need opposite fixes when they disagree.

     Three events, seen -> open -> add. Strictly fire-and-forget: wrapped in try/catch and never
     awaited, because a bundle must never fail to reach the cart over a logging problem. */
  var LOG_ENDPOINT = 'https://llmedico-meilisearch-sync.llmedico.workers.dev/fbt-log';
  var loggedEvents = {};

  function bundleTotalCents() {
    var total = 0;
    rows.forEach(function (row) {
      var s = rowState(row);
      if (s.checked) total += s.cents || 0;
    });
    return total;
  }

  function logFbt(event, extra) {
    // Once per event per page load. Without this, 'seen' re-fires every time the block scrolls back
    // into view and the impression count quietly inflates against a flat 'add' count.
    if (loggedEvents[event]) return;
    loggedEvents[event] = 1;
    try {
      var payload = JSON.stringify({
        event: event,
        anchor: root.getAttribute('data-anchor-gid') || '',
        items: extra && extra.items,
        value: extra && extra.value,
        page: location.pathname,
      });
      /* ⚠️ text/plain, NOT application/json — same trap that kept the search log empty for a day.
         sendBeacon may only send CORS-safelisted content types; application/json makes it a
         non-simple cross-origin request needing a preflight, and a beacon cannot preflight, so the
         browser drops it SILENTLY (no console error, no network entry). The worker calls
         request.json() regardless of the declared type, so the label costs nothing.
         sendBeacon also matters here specifically: the 'add' event fires immediately before
         window.location.href = '/cart', and a plain fetch would be cancelled by that navigation. */
      if (navigator.sendBeacon) {
        navigator.sendBeacon(LOG_ENDPOINT, new Blob([payload], { type: 'text/plain' }));
      } else {
        fetch(LOG_ENDPOINT, { method: 'POST', body: payload, keepalive: true,
          headers: { 'Content-Type': 'text/plain' } }).catch(function () {});
      }
    } catch (e) { /* analytics must never throw into the add-to-cart path */ }
  }

  /* 'seen' is INTERSECTION-GATED, not one-per-pageview. The FBT block sits below the buy box, so a
     large share of PDP visitors never scroll to it — counting every page view as an impression would
     understate the open rate against a denominator of people who never had the chance. It also keeps
     the row count proportional to real exposure rather than to site traffic.
     No IntersectionObserver (old browser) => no 'seen' row, rather than a guessed one. */
  if (typeof IntersectionObserver === 'function') {
    var seenObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        logFbt('seen');
        seenObserver.disconnect();
      });
    }, { threshold: 0.5 });
    seenObserver.observe(root);
  }

  /* ---- open / close ------------------------------------------------------------------------- */
  // Above 750px the sheet is rendered inline (see llm-fbt.css) — there is nothing to open or close,
  // and locking body scroll there would freeze the page for a control the customer never invoked.
  var isSheetLayout = function () { return window.matchMedia('(max-width: 749.98px)').matches; };

  var lastFocus = null;
  function open() {
    if (!isSheetLayout()) return;
    /* ⚠️ AFTER the layout guard, on purpose. Above 750px the sheet is rendered INLINE — there is no
       open action, so 'open' is a MOBILE-ONLY event. Read the funnel accordingly: seen->open->add
       holds on phones, while desktop goes seen->add with no middle step. Logging it before the guard
       would invent an "open" every time a desktop customer clicked a control that does nothing. */
    logFbt('open');
    lastFocus = document.activeElement;
    scrim.hidden = false;
    sheet.hidden = false;
    document.body.classList.add('llm-fbt-locked');
    /* Force a reflow so the browser records the closed transform as the transition's start value,
       THEN flip the class. This was a requestAnimationFrame callback, which does not fire at all in
       a background tab — leaving the sheet un-hidden but still at its closed transform. Reading
       offsetHeight is synchronous, so the sheet can never be left half-opened. */
    void sheet.offsetHeight;
    sheet.classList.add('is-open');
    var first = sheet.querySelector('button, select, input, a');
    if (first) first.focus();
  }
  function close() {
    if (!isSheetLayout()) return;
    sheet.classList.remove('is-open');
    document.body.classList.remove('llm-fbt-locked');
    var done = function () { sheet.hidden = true; scrim.hidden = true; };
    // Wait for the slide-down, but never leave it stuck open if the transition never fires.
    var fallback = setTimeout(done, 400);
    sheet.addEventListener('transitionend', function h() {
      clearTimeout(fallback); sheet.removeEventListener('transitionend', h); done();
    });
    if (lastFocus) lastFocus.focus();
  }

  root.querySelector('[data-llm-fbt-open]').addEventListener('click', open);
  root.querySelector('[data-llm-fbt-close]').addEventListener('click', close);
  scrim.addEventListener('click', close);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !sheet.hidden) close();
  });

  /* ---- add to cart -------------------------------------------------------------------------- */
  addBtn.addEventListener('click', function () {
    /* Tag every line with the bundle's anchor product so the discount function can recognise it.
       Underscore-prefixed, so Shopify hides it from the customer in cart and checkout. The function
       does not trust this on its own — it re-verifies the combination against the anchor's
       custom.fbt_products metafield before discounting. */
    var anchorGid = root.getAttribute('data-anchor-gid') || '';
    var items = [];
    rows.forEach(function (row) {
      var s = rowState(row);
      if (s.checked && s.variantId) {
        items.push({
          id: Number(s.variantId),
          quantity: 1,
          /* TWO properties, doing two different jobs — do not collapse them.
             _fbt_bundle  the discount function's input: it re-verifies this anchor against the
                          product's custom.fbt_products metafield before discounting.
             _source      the store-wide FEATURE-ADOPTION convention, shared with quick-reorder,
                          account-buy-again and collection-helper, and the thing zz_feature_adoption.mjs
                          reads. FBT had only the first, so every _source-based adoption report
                          silently counted FBT as ZERO — the same shape of measurement gap that made
                          collection-helper read 0 orders when the finder was in fact selling. */
          properties: { _fbt_bundle: anchorGid, _source: 'fbt' },
        });
      }
    });
    if (items.length < 2) return;

    logFbt('add', { items: items.length, value: bundleTotalCents() });

    addBtn.classList.add('is-busy');
    addBtn.disabled = true;

    // One /cart/add.js call with every line: it is atomic, so the customer never ends up with half a
    // bundle if one item has just gone out of stock.
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items }),
    })
      .then(function (r) { return r.json().then(function (b) { return { ok: r.ok, body: b }; }); })
      .then(function (res) {
        if (!res.ok) throw new Error(res.body && res.body.description ? res.body.description : 'Add to cart failed');
        // Let the theme's own cart drawer/count update rather than reimplementing it.
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        document.dispatchEvent(new CustomEvent('cart:build', { bubbles: true }));
        close();
        window.location.href = '/cart';
      })
      .catch(function (err) {
        addBtn.classList.remove('is-busy');
        addBtn.disabled = false;
        if (hint) { hint.hidden = false; hint.textContent = err.message || 'Something went wrong — please try again.'; }
      });
  });

  /* ANCHOR ROW = the product being viewed. It inherits whatever variant is selected on the page,
     because the customer has already chosen it right above this block; making them choose again is
     friction and reads as a broken bundle (owner 2026-09-05).

     Deliberately NOT a Liquid-side preselect of the label/price: the snippet emits only the id, and
     this resolves it through selectVariant() — the same path a real click takes — so the label,
     price, bundle total and the amber is-unset state all come from one implementation.

     byUser is false, so this never sets the row's userSet flag and never blocks size mirroring. */
  function syncAnchor(variantId) {
    var row = root.querySelector('[data-llm-fbt-anchor]');
    if (!row) return;
    var id = String(variantId || row.getAttribute('data-llm-fbt-preselect') || '');
    if (!id) return;
    var list = variantsOf(row);
    /* If the customer is viewing an OUT-OF-STOCK variant, leave the row unset rather than quietly
       choosing a different size. The snippet used to emit only available variants, so this fell out
       of the lookup failing; now that sold-out ones are listed for display, the check has to be
       explicit or the bundle would carry a line that cannot be added. */
    for (var i = 0; i < list.length; i++) {
      if (String(list[i].i) !== id) continue;
      if (isBuyable(list[i])) selectVariant(row, list[i], false);
      return;
    }
  }

  /* ANCHOR -> PAGE. The mirror of syncAnchor, for the other direction (owner 2026-09-05: "if I choose
     MD in the FBT, should the main variant selector change to MD too?"). Yes — otherwise one product
     shows two prices on one page and the bundle adds a variant the buy box never displayed.

     Drives the theme's own <variant-picker> instead of hand-patching price/gallery/URL: selecting the
     option the way a click does makes the theme update the price, images, availability, the
     Add-to-cart variant id and the ?variant= URL in one render. Nothing here duplicates that logic.

     Join key is v.f, the RAW variant title. v.t is a cleaned label for the bundle UI — colour prefix
     and marketing suffixes stripped — and matches NO option value on the page (measured: v.t 0/72,
     v.f 72/72 on MEGAMAX). Values are compared, never interpolated into a selector: they contain
     inch marks, which would break an attribute selector. */
  function pushToPicker(v) {
    var picker = document.querySelector('variant-picker');
    if (!picker) return;
    var selectors = picker.querySelectorAll('.option-selector:not(.option-selector--custom)');
    if (!selectors.length) return;

    // One selector carrying the whole combined title is the catalogue convention. Multi-option
    // products split on Shopify's ' / ' separator — never ' | ', which appears INSIDE our values.
    var raw = String(v.f || v.t || '');
    var parts = selectors.length > 1 ? raw.split(' / ') : [raw];
    if (parts.length !== selectors.length) return;   // cannot map confidently — leave the page alone

    var pending = [];
    for (var i = 0; i < selectors.length; i++) {
      var sel = selectors[i], want = parts[i], opt = null, input = null, j;
      var opts = sel.querySelectorAll('.custom-select__option');
      for (j = 0; j < opts.length; j++) if (opts[j].getAttribute('data-value') === want) { opt = opts[j]; break; }
      if (!opt) {
        var ins = sel.querySelectorAll('input.js-option');
        for (j = 0; j < ins.length; j++) if (ins[j].value === want) { input = ins[j]; break; }
      }
      if (!opt && !input) return;                    // value is not on the page — do nothing
      if (opt && opt.getAttribute('aria-selected') === 'true') continue;
      if (input && input.checked) continue;
      pending.push({ opt: opt, input: input, sel: sel, want: want });
    }
    // Each selection re-renders the picker, so applying two would race its own DOM replacement.
    // Already in step (0) or needing more than one change: leave it to the customer, half-applied is
    // worse than untouched.
    if (pending.length !== 1) return;

    var p = pending[0];
    if (p.opt) {
      var custom = p.opt.closest('custom-select');
      if (custom && typeof custom.selectOption === 'function') {
        /* Suppress the theme's post-change .focus() on the buy-box select button. Focusing it scrolls
           it into view, which threw the page back to the top the moment a customer changed the option
           down in the bundle (owner 2026-09-05: measured scrollY 1310 -> 53 at the exact millisecond
           focus moved to #product-form-…-button).

           noFocus is the theme's OWN opt-out — variant-picker.js honours it and applySearchParams
           uses it for exactly this reason. custom-select dispatches change with a detail object and
           this listener runs on it before the event reaches <variant-picker>, so mutating the detail
           in flight is enough; no second dispatch, which would re-run the whole variant update.

           Guarded: the other custom-select branch (products with a native <select>) emits a plain
           Event with detail null. Rather than throw, that degrades to the old scrolling behaviour. */
        custom.addEventListener('change', function mark(evt) {
          if (evt.detail && typeof evt.detail === 'object') evt.detail.noFocus = true;
        }, { once: true });
        custom.selectOption(p.opt);
      }
    } else {
      var label = p.sel.querySelector('.option-selector__label-value');
      if (label) label.textContent = p.want;
      p.input.checked = true;
      p.input.dispatchEvent(new CustomEvent('change', { bubbles: true, cancelable: false, detail: { noFocus: true } }));
    }
  }

  /* Follow the page. The theme fires on:variant:change when the picker changes (llm-autoship.js
     listens to the same event), so the FBT row cannot drift out of step with the buy box. */
  document.addEventListener('on:variant:change', function (e) {
    var v = e && e.detail && e.detail.variant;
    if (v && v.id) syncAnchor(v.id);
  });

  /* PRESELECT partner rows whose choice is not a SIZE decision.
     The no-preselect rule exists to stop wrong-size shipments on sized medical products — a real
     risk worth a click. But plenty of partners only differ by pack quantity ("Single" vs "Box of
     50"), and on the Tegaderm page that left a row with no price at all until the customer opened
     a dropdown to pick the only sensible option (owner 2026-09-05).

     The test is the size token itself, reusing the same helper the size-mirroring uses: if NOT ONE
     variant carries a size (XS/SM/MD/LG/XL/2XL…), this is not a sizing decision and the cheapest —
     i.e. the single — is a safe default. Anything with sizes still requires a deliberate choice.

     byUser is false, so the row is not marked userSet and size mirroring can still override it. */
  function preselectUnsized() {
    rows.forEach(function (row) {
      if (row.hasAttribute('data-llm-fbt-anchor')) return;         // anchor is handled by syncAnchor
      var field = row.querySelector('[data-llm-fbt-variant]');
      if (!field || field.value) return;                            // already chosen or single-variant
      var list = variantsOf(row);
      if (list.length < 2) return;
      var anySized = list.some(function (v) { return !!sizeToken(v.f || v.t); });
      if (anySized) return;
      // Cheapest EXCLUDING samples/trials — they are the cheapest variant of almost every product,
      // so the unfiltered pick was a sample nearly every time it had one.
      var pool = list.filter(function (v) { return !isSampleOrTrial(v) && isBuyable(v); });
      if (!pool.length) return;                // nothing but samples / sold out — customer chooses
      var cheapest = pool.reduce(function (a, b) { return b.p < a.p ? b : a; }, pool[0]);
      if (cheapest) selectVariant(row, cheapest, false);
    });
  }

  syncAnchor();
  preselectUnsized();
  refresh();
  mirrorWhenReady(20);   // ~3s of polling; sets what it can confidently match, then refreshes
})();
